// Yves Rocher LP scripts（ローカル共通。Shopify 納品でも main.js を *_lp.js としてコピー）
function initYvesRocherLp() {
  const rinsing = document.querySelector(".yr-lp-rinsing");
  if (rinsing) initRinsingLp(rinsing);

  const repair = document.querySelector(".yr-lp-repair");
  if (repair) initRepairLp(repair);

  const twoBuy = document.querySelector(".yr-lp-two-buy-one-get");
  if (twoBuy) initTwoBuyOneGetLp(twoBuy);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initYvesRocherLp, { once: true });
} else {
  initYvesRocherLp();
}

function initRinsingLp(root) {
  initScrollReveal(root);
  initStepLabelArrows(root);
  initDiagnosis(root);
  initBeforeAfter(root);
  initLineupTabs(root);
  initLineupScrollHint(root);
  initFaqAccordion(root);
  initSmoothAnchors(root);
  initRinsingInstagramSeeMore(root);
}

/**
 * Rinsing Instagram（LEEEP）: 続き投稿が無くなったら「もっと見る」を非表示。
 * Repair の canLoadMore 判定と同じ（display:none / LeeepHide / aria-hidden）。
 */
function initRinsingInstagramSeeMore(root) {
  const tag = root.querySelector(".yr-lp__insta__embed [id^='leeep-tag-']");
  if (!tag) return;

  const tagId = tag.id.replace(/^leeep-tag-/, "");
  const getEmbedded = () => document.getElementById(`leeep-embedded-${tagId}`);
  const getSeeMore = () =>
    getEmbedded()?.querySelector(".LeeepStaffPostListSeeMore, .LeeepSeeMore");

  const isExhausted = (more) => {
    if (!more) return true;
    if (more.classList.contains("LeeepHide") || more.getAttribute("aria-hidden") === "true") {
      return true;
    }
    return more.style.display === "none";
  };

  const sync = () => {
    const more = getSeeMore();
    if (!more) return;

    if (more.dataset.yrLeeepWatch !== "1") {
      more.dataset.yrLeeepWatch = "1";
      more.addEventListener("click", () => {
        window.setTimeout(sync, 400);
        window.setTimeout(sync, 2000);
      });
      new MutationObserver(sync).observe(more, {
        attributes: true,
        attributeFilter: ["style", "class", "hidden", "aria-hidden"],
      });
    }

    more.toggleAttribute("hidden", isExhausted(more));
  };

  const observer = new MutationObserver(() => {
    sync();
  });
  observer.observe(tag, { childList: true, subtree: true, attributes: true });
  if (tag.parentElement) {
    observer.observe(tag.parentElement, { childList: true, subtree: true });
  }

  // LEEEP 初期化待ち
  const started = Date.now();
  const timer = window.setInterval(() => {
    sync();
    if (getSeeMore() || Date.now() - started > 8000) {
      window.clearInterval(timer);
    }
  }, 300);

  sync();
}

function initStepLabelArrows(root) {
  const steps = root.querySelector(".yr-lp__steps");
  if (!steps) return;

  const mq = window.matchMedia("(min-width: 769px)");

  const sync = () => {
    if (!mq.matches) return;

    const items = [...steps.querySelectorAll(":scope > .yr-lp__steps__item")];
    items.forEach((item, index) => {
      const label = item.querySelector(".yr-lp__steps__label");
      const nextLabel = items[index + 1]?.querySelector(".yr-lp__steps__label");
      if (!label) return;

      item.style.setProperty(
        "--yr-step-label-w",
        `${Math.round(label.getBoundingClientRect().width)}px`,
      );
      if (nextLabel) {
        item.style.setProperty(
          "--yr-step-next-label-w",
          `${Math.round(nextLabel.getBoundingClientRect().width)}px`,
        );
      }
    });
  };

  sync();
  mq.addEventListener("change", sync);
  window.addEventListener("resize", sync);
  if (document.fonts?.ready) document.fonts.ready.then(sync);
  new ResizeObserver(sync).observe(steps);
}

function initRepairLp(root) {
  initScrollReveal(
    root,
    [
      ".yr-lp__mv__content > *",
      ".yr-lp__section--01 .yr-lp__section__inner > *",
      ".yr-lp__section02__head",
      ".yr-lp__section02__lead",
      ".yr-lp__section02__approach > *",
      ".yr-lp__section02__ingredient",
      ".yr-lp__section03__head",
      ".yr-lp__lineup-step",
      ".yr-lp__fragrance__head",
      ".yr-lp__fragrance__lead",
      ".yr-lp__fragrance__note",
      ".yr-lp__fragrance__closing",
      ".yr-lp__instagram__head",
      ".yr-lp__instagram__embed",
      ".yr-lp__instagram__cta",
      ".yr-lp__faq__head",
      ".yr-lp__faq__item",
      ".yr-lp__closing-shop__inner > *",
    ].join(", "),
  );
  initRepairInstagramCta(root);
  initFaqAccordion(root);
  initSmoothAnchors(root);
}

function initTwoBuyOneGetLp(root) {
  initFaqAccordion(root);
  initSmoothAnchors(root);
  initTwoBuyProductsScroll(root);
  initTwoBuyScriptReveal(root);
  initCampaignModals(root);
}

function initTwoBuyScriptReveal(root) {
  const scripts = root.querySelectorAll(
    ".yr-lp__script--products-2buy, .yr-lp__script--products-1get",
  );
  if (!scripts.length) return;

  const reveal = () => {
    scripts.forEach((el) => el.classList.add("is-revealed"));
  };

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    reveal();
    return;
  }

  if (typeof IntersectionObserver === "undefined") {
    reveal();
    return;
  }

  // clip-path で隠した要素は intersection ratio が 0 のままになるため、
  // 親コンテナを監視して子スクリプトを reveal する
  const targets = new Set();
  scripts.forEach((el) => {
    targets.add(el.closest(".yr-lp__products, .yr-lp__present") || el);
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const scope = entry.target;
        scope
          .querySelectorAll(
            ".yr-lp__script--products-2buy, .yr-lp__script--products-1get",
          )
          .forEach((el) => el.classList.add("is-revealed"));
        if (scope.classList?.contains("yr-lp__script")) {
          scope.classList.add("is-revealed");
        }
        io.unobserve(scope);
      });
    },
    { threshold: 0.2, rootMargin: "0px 0px -8% 0px" },
  );

  targets.forEach((el) => io.observe(el));
}

function initCampaignModals(root) {
  const modals = [
    ...root.querySelectorAll("dialog.yr-lp__campaign-modal"),
    ...document.querySelectorAll("dialog.yr-lp__campaign-modal"),
  ].filter((modal, index, list) => list.indexOf(modal) === index);

  if (!modals.length) return;

  const syncHtml = () => {
    const anyOpen = modals.some((modal) => modal.open);
    document.documentElement.classList.toggle("is-campaign-modal-open", anyOpen);
  };

  const getModal = (id) => modals.find((modal) => modal.id === id) || document.getElementById(id);

  const resetModalScroll = (modal) => {
    modal.scrollTop = 0;
    modal.scrollLeft = 0;
  };

  // showModal 直後は先頭の × にフォーカスが乗り、iOS 等で focus-visible の緑 outline が常時出るため dialog へ移す
  const focusModalForOpen = (modal) => {
    if (!modal.hasAttribute("tabindex")) {
      modal.setAttribute("tabindex", "-1");
    }
    modal.focus({ preventScroll: true });
  };

  const openModal = (id, event) => {
    event?.preventDefault();
    const modal = getModal(id);
    if (!modal || typeof modal.showModal !== "function") return;

    modals.forEach((other) => {
      if (other !== modal && other.open) other.close();
    });

    if (modal.open) {
      syncHtml();
      return;
    }

    try {
      modal.showModal();
    } catch (error) {
      modal.setAttribute("open", "");
    }
    resetModalScroll(modal);
    focusModalForOpen(modal);
    syncHtml();
  };

  const closeModal = (id, event) => {
    event?.preventDefault();
    const modal = getModal(id);
    if (!modal) return;
    if (modal.open) modal.close();
    else modal.removeAttribute("open");
    syncHtml();
  };

  window.yrOpenReceiptModal = (event) => openModal("receipt-photo-modal", event);
  window.yrCloseReceiptModal = (event) => closeModal("receipt-photo-modal", event);
  window.yrOpenTermsModal = (event) => openModal("campaign-terms-modal", event);
  window.yrCloseTermsModal = (event) => closeModal("campaign-terms-modal", event);

  document.addEventListener(
    "click",
    (event) => {
      const closer = event.target.closest?.("[data-modal-close]");
      if (closer) {
        closeModal(closer.getAttribute("data-modal-close"), event);
      }

      const opener = event.target.closest?.("[data-modal-open]");
      if (opener) {
        openModal(opener.getAttribute("data-modal-open"), event);
      }
    },
    true,
  );

  modals.forEach((modal) => {
    modal.addEventListener("click", (event) => {
      if (event.target === modal) closeModal(modal.id, event);
    });
    modal.addEventListener("close", syncHtml);
  });
}

function initTwoBuyProductsScroll(root) {
  const track = root.querySelector("[data-products-track]");
  if (!track) return;

  const products = Array.from(track.querySelectorAll(".yr-lp__product"));
  if (!products.length) return;

  const prev = root.querySelector(".yr-lp__products__nav--prev");
  const next = root.querySelector(".yr-lp__products__nav--next");
  const thumbsWrap = root.querySelector("[data-products-thumbs]");
  const viewer = root.querySelector("[data-products-viewer]");
  const mqSp = window.matchMedia("(max-width: 768px)");
  let index = 0;
  let thumbs = [];

  const step = () => {
    const card = track.querySelector(".yr-lp__product");
    return card ? card.getBoundingClientRect().width + 16 : 280;
  };

  const syncThumbs = () => {
    thumbs.forEach((btn, i) => {
      const active = i === index;
      btn.classList.toggle("is-active", active);
      btn.setAttribute("aria-selected", active ? "true" : "false");
      btn.tabIndex = active ? 0 : -1;
    });
  };

  const showSp = (nextIndex) => {
    index = (nextIndex + products.length) % products.length;
    products.forEach((product, i) => {
      product.classList.toggle("is-active", i === index);
      product.setAttribute("aria-hidden", i === index ? "false" : "true");
    });
    syncThumbs();
  };

  const enableFade = () => {
    window.requestAnimationFrame(() => {
      track.classList.add("is-fading");
    });
  };

  const buildThumbs = () => {
    if (!thumbsWrap || thumbs.length) return;

    products.forEach((product, i) => {
      const src = product.querySelector(".yr-lp__product__media img")?.getAttribute("src");
      if (!src) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "yr-lp__products__thumb";
      btn.setAttribute("role", "tab");
      btn.setAttribute("aria-label", `商品 ${i + 1}`);
      btn.dataset.productIndex = String(i);

      const img = document.createElement("img");
      img.src = src;
      img.alt = "";
      img.width = 44;
      img.height = 46;
      img.decoding = "async";
      btn.appendChild(img);

      btn.addEventListener("click", () => {
        if (!mqSp.matches) return;
        showSp(i);
      });

      thumbsWrap.appendChild(btn);
    });

    thumbs = Array.from(thumbsWrap.querySelectorAll(".yr-lp__products__thumb"));
  };

  const applyMode = () => {
    buildThumbs();

    if (mqSp.matches) {
      track.scrollLeft = 0;
      track.classList.remove("is-fading");
      showSp(index);
      enableFade();
      return;
    }

    track.classList.remove("is-fading");

    products.forEach((product) => {
      product.classList.remove("is-active");
      product.removeAttribute("aria-hidden");
    });
    thumbs.forEach((btn) => {
      btn.classList.remove("is-active");
      btn.removeAttribute("aria-selected");
      btn.tabIndex = 0;
    });
  };

  prev?.addEventListener("click", () => {
    if (mqSp.matches) showSp(index - 1);
    else track.scrollBy({ left: -step(), behavior: "smooth" });
  });

  next?.addEventListener("click", () => {
    if (mqSp.matches) showSp(index + 1);
    else track.scrollBy({ left: step(), behavior: "smooth" });
  });

  if (viewer) {
    let touchStartX = 0;
    let touchDeltaX = 0;

    viewer.addEventListener(
      "touchstart",
      (event) => {
        if (!mqSp.matches || event.touches.length !== 1) return;
        touchStartX = event.touches[0].clientX;
        touchDeltaX = 0;
      },
      { passive: true },
    );

    viewer.addEventListener(
      "touchmove",
      (event) => {
        if (!mqSp.matches || event.touches.length !== 1) return;
        touchDeltaX = event.touches[0].clientX - touchStartX;
      },
      { passive: true },
    );

    viewer.addEventListener("touchend", () => {
      if (!mqSp.matches) return;
      if (Math.abs(touchDeltaX) < 40) return;
      if (touchDeltaX < 0) showSp(index + 1);
      else showSp(index - 1);
      touchDeltaX = 0;
    });
  }

  if (typeof mqSp.addEventListener === "function") {
    mqSp.addEventListener("change", applyMode);
  } else if (typeof mqSp.addListener === "function") {
    mqSp.addListener(applyMode);
  }

  applyMode();
}

function initRepairInstagramCta(root) {
  const section = root.querySelector(".yr-lp__instagram");
  const cta = root.querySelector(".yr-lp__instagram__cta");
  const empty = root.querySelector(".yr-lp__instagram__empty");
  const tag = root.querySelector(".yr-lp__instagram__embed [id^='leeep-tag-']");
  if (!section || !cta || !empty || !tag) return;

  const tagId = tag.id.replace(/^leeep-tag-/, "");

  // 実測（空タグ）: /v3/posts が posts:[] のとき #leeep-embedded-* は残らず、
  // #leeep-tag-* は空のまま。投稿あり時は .LeeepPost:not(.LeeepEmpty) が並ぶ。
  const getEmbedded = () => document.getElementById(`leeep-embedded-${tagId}`);

  const countPosts = () => {
    const embedded = getEmbedded();
    if (!embedded) return 0;

    const posts = embedded.querySelectorAll(".LeeepPost:not(.LeeepEmpty)");
    if (posts.length > 0) return posts.length;

    // Tab 等で .LeeepPost のクラス付与が遅いときのフォールバック
    return embedded.querySelectorAll(
      ".LeeepListMedia img.LeeepLoadedImg[src], .LeeepListMedia video.LeeepLoadedVideo[src]",
    ).length;
  };

  const getSeeMore = () => {
    const embedded = getEmbedded();
    return embedded?.querySelector(
      ".LeeepStaffPostListSeeMore, .LeeepSeeMore",
    );
  };

  // LEEEP は続きなしで SeeMore に inline style="display: none;" を付与（LeeepHide は付かないこともある）
  const canLoadMore = () => {
    const more = getSeeMore();
    if (!more) return false;
    if (more.classList.contains("LeeepHide") || more.getAttribute("aria-hidden") === "true") {
      return false;
    }
    return more.style.display !== "none";
  };

  const bindSeeMoreWatch = () => {
    const more = getSeeMore();
    if (!more || more.dataset.yrLeeepWatch === "1") return;
    more.dataset.yrLeeepWatch = "1";
    new MutationObserver(() => {
      applyState(countPosts());
    }).observe(more, {
      attributes: true,
      attributeFilter: ["style", "class", "hidden", "aria-hidden"],
    });
  };

  const applyState = (postCount) => {
    const hasPosts = postCount > 0;
    section.classList.toggle("is-empty", !hasPosts);
    empty.hidden = hasPosts;
    cta.hidden = !hasPosts || !canLoadMore();
    if (hasPosts) bindSeeMoreWatch();
  };

  const settleInstagram = () => {
    const started = Date.now();
    const maxWaitMs = 8000;
    const minEmptyMs = 2500;

    const tick = () => {
      const postCount = countPosts();
      const elapsed = Date.now() - started;
      const embedded = getEmbedded();
      const placeholders = embedded
        ? embedded.querySelectorAll(".LeeepPost.LeeepEmpty").length
        : 0;

      // 投稿あり → CTA（空メッセージは出さない）。続きなしなら CTA も隠す
      if (postCount > 0) {
        applyState(postCount);
        return elapsed >= maxWaitMs;
      }

      // スケルトン読込中
      if (embedded && placeholders > 0) return false;

      // 埋め込みは出たがプレースホルダ解消後も投稿0 → 空（早すぎる確定を避ける）
      if (embedded && placeholders === 0 && elapsed >= minEmptyMs) {
        applyState(0);
        return elapsed >= maxWaitMs;
      }

      // 埋め込み自体が作られない空（実測どおり）→ 上限待ち後に空
      if (!embedded && elapsed >= maxWaitMs) {
        applyState(0);
        return true;
      }

      return false;
    };

    if (tick()) return;

    const observer = new MutationObserver(() => {
      if (tick()) observer.disconnect();
    });
    observer.observe(tag, { childList: true, subtree: true, attributes: true });
    if (tag.parentElement) {
      observer.observe(tag.parentElement, { childList: true, subtree: true });
    }

    const timer = window.setInterval(() => {
      if (tick()) {
        window.clearInterval(timer);
        observer.disconnect();
      }
    }, 300);
  };

  cta.addEventListener("click", () => {
    const more = getSeeMore();
    if (more) more.click();
    window.setTimeout(() => applyState(countPosts()), 400);
    window.setTimeout(() => applyState(countPosts()), 2000);
  });

  settleInstagram();
}

function initScrollReveal(root, selector) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  const revealSelector =
    selector ||
    [
      ".yr-lp__section--01 .yr-lp__section__inner > *",
      ".yr-lp__steps__item",
      ".yr-lp__diag__head",
      ".yr-lp__diag__col",
      ".yr-lp__series-head",
      ".yr-lp__series-points",
      ".yr-lp__series-scentba > *",
      ".yr-lp__plant-guide",
      ".yr-lp__series-cta__item",
      ".yr-lp__compare__head",
      ".yr-lp__compare__heroes > *",
      ".yr-lp__compare-table",
      ".yr-lp__howto__notes-block",
      ".yr-lp__howto__head",
      ".yr-lp__howto__video",
      ".yr-lp__howto__step",
      ".yr-lp__howto__step-arrow",
      ".yr-lp__lineup__head",
      ".yr-lp__lineup__card",
      ".yr-lp__faq__head",
      ".yr-lp__faq__item",
      ".yr-lp__insta__head",
      ".yr-lp__insta__embed",
      ".yr-lp__revisit__head",
      ".yr-lp__revisit__back",
      ".yr-lp__revisit__cta",
      ".yr-lp__closing-shop__content > *",
    ].join(", ");

  const isSp = window.matchMedia("(max-width: 768px)").matches;
  const targets = [...root.querySelectorAll(revealSelector)].filter((el) => {
    if (!isSp) return true;
    return !el.matches(".yr-lp__howto__step, .yr-lp__howto__step-arrow");
  });
  if (!targets.length) return;

  const grouped = new Map();
  const revealInView = (el) => {
    const rect = el.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight || 0;
    return rect.top < viewportHeight * 0.88 && rect.bottom > 0;
  };

  targets.forEach((el) => {
    const group =
      el.closest(".yr-lp__mv, .yr-lp__section") ||
      el.parentElement ||
      root;
    if (!grouped.has(group)) grouped.set(group, []);
    grouped.get(group).push(el);
  });

  grouped.forEach((els) => {
    els.forEach((el, index) => {
      el.classList.add("yr-lp__reveal");
      el.style.setProperty("--yr-reveal-delay", `${Math.min(index, 5) * 90}ms`);
    });
  });

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: "0px 0px -12% 0px",
      threshold: 0.15,
    },
  );

  targets.forEach((el) => {
    if (revealInView(el)) {
      el.classList.add("is-visible");
      return;
    }
    observer.observe(el);
  });
}

function initDiagnosis(root) {
  root.querySelectorAll("[data-diag]").forEach((card) => {
    const countEl = card.querySelector("[data-diag-count]");
    const boxes = card.querySelectorAll('input[type="checkbox"]');
    if (!countEl || !boxes.length) return;

    const update = () => {
      const n = [...boxes].filter((box) => box.checked).length;
      countEl.textContent = String(n);
    };

    boxes.forEach((box) => box.addEventListener("change", update));
    update();
  });
}

function initBeforeAfter(root) {
  root.querySelectorAll("[data-ba]").forEach((slider) => {
    const wrap = slider.querySelector(".yr-lp__ba__before-wrap");
    const handle = slider.querySelector(".yr-lp__ba__handle");
    if (!wrap || !handle) return;

    let activePointerId = null;

    const setPos = (clientX) => {
      const rect = slider.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
      const pct = `${(ratio * 100).toFixed(2)}%`;
      wrap.style.width = pct;
      handle.style.left = pct;
      handle.setAttribute("aria-valuenow", String(Math.round(ratio * 100)));
    };

    const stop = () => {
      activePointerId = null;
    };

    const onPointerMove = (event) => {
      if (activePointerId !== event.pointerId) return;
      setPos(event.clientX);
    };

    const onPointerDown = (event) => {
      if (event.button !== 0) return;
      activePointerId = event.pointerId;
      slider.setPointerCapture(event.pointerId);
      event.preventDefault();
      setPos(event.clientX);
    };

    const onPointerUp = (event) => {
      if (activePointerId !== event.pointerId) return;
      stop();
    };

    slider.addEventListener("pointerdown", onPointerDown);
    slider.addEventListener("pointermove", onPointerMove);
    slider.addEventListener("pointerup", onPointerUp);
    slider.addEventListener("pointercancel", onPointerUp);
    slider.addEventListener("lostpointercapture", stop);

    handle.addEventListener("keydown", (event) => {
      const current = Number(handle.getAttribute("aria-valuenow") || 50);
      let next = current;
      if (event.key === "ArrowLeft") next = current - 2;
      if (event.key === "ArrowRight") next = current + 2;
      if (next === current) return;
      event.preventDefault();
      const rect = slider.getBoundingClientRect();
      setPos(rect.left + (Math.min(100, Math.max(0, next)) / 100) * rect.width);
    });
  });
}

function initLineupTabs(root) {
  const tabs = root.querySelectorAll("[data-lineup-tab]");
  const cards = [...root.querySelectorAll(".yr-lp__lineup__card")];
  const scroller = root.querySelector(".yr-lp__lineup__scroller");
  if (!tabs.length) return;

  const FADE_MS = 350;
  let filterToken = 0;

  const fadeIn = (card) => {
    card.hidden = false;
    card.classList.add("is-filtering-out");
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        card.classList.remove("is-filtering-out");
      });
    });
  };

  const notifyLineupUpdated = () => {
    if (!scroller) return;
    scroller.dispatchEvent(new CustomEvent("yr-lineup-updated"));
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const filter = tab.getAttribute("data-lineup-tab");
      const token = ++filterToken;
      tabs.forEach((item) => item.classList.toggle("is-active", item === tab));

      const toShow = [];
      const toHide = [];
      cards.forEach((card) => {
        const line = card.getAttribute("data-line");
        const shouldShow = filter === "all" || line === filter;
        if (shouldShow) {
          if (card.hidden || card.classList.contains("is-filtering-out")) {
            toShow.push(card);
          }
        } else if (!card.hidden) {
          toHide.push(card);
        }
      });

      // 消えるカードが幅を占有したまま次カードが出ると右に一瞬並び、
      // その後左へガクッと寄る。必ずフェードアウト完了後に差し替える。
      toHide.forEach((card) => card.classList.add("is-filtering-out"));

      const reveal = () => {
        if (token !== filterToken) return;
        toHide.forEach((card) => {
          card.hidden = true;
          card.classList.remove("is-filtering-out");
        });
        toShow.forEach((card) => fadeIn(card));
        if (scroller) scroller.scrollLeft = 0;
        // カード差し替え後の横スクロール可否でヒントを再判定（dismissed は保持）
        notifyLineupUpdated();
        requestAnimationFrame(notifyLineupUpdated);
      };

      if (toHide.length) {
        window.setTimeout(reveal, FADE_MS);
      } else {
        reveal();
      }
    });
  });
}

/**
 * ラインナップ SP スクロールヒント（0926 #3）
 * 表示 = 未 dismiss かつ横スクロール可能。一度スクロールしたら再表示しない。
 */
function initLineupScrollHint(root) {
  const scroller = root.querySelector(".yr-lp__lineup__scroller");
  const hint = root.querySelector(".yr-lp__lineup__scroll-hint");
  if (!scroller || !hint) return;

  let dismissed = false;
  const SCROLL_DISMISS_PX = 8;
  const OVERFLOW_PAD_PX = 4;

  const canScrollHorizontally = () =>
    scroller.scrollWidth > scroller.clientWidth + OVERFLOW_PAD_PX;

  const sync = () => {
    if (scroller.scrollLeft > SCROLL_DISMISS_PX) {
      dismissed = true;
    }
    const show = !dismissed && canScrollHorizontally();
    hint.classList.toggle("is-hidden", !show);
  };

  scroller.addEventListener("scroll", sync, { passive: true });
  scroller.addEventListener("yr-lineup-updated", sync);
  window.addEventListener("resize", sync, { passive: true });

  if (typeof ResizeObserver !== "undefined") {
    new ResizeObserver(sync).observe(scroller);
  }

  sync();
}

function initSmoothAnchors(root) {
  const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const getOffset = () => {
    let offset = 24;
    const nodes = [
      ...document.querySelectorAll(
        "sticky-header, #shopify-section-header, #shopify-section-announcement-bar, .shopify-section-group-header-group, .header-wrapper",
      ),
      document.querySelector(".local-nav"),
    ].filter(Boolean);

    nodes.forEach((el) => {
      const style = window.getComputedStyle(el);
      const rect = el.getBoundingClientRect();
      if (style.position === "fixed" || style.position === "sticky") {
        offset = Math.max(offset, Math.ceil(rect.bottom) + 16);
      } else if (el.classList.contains("local-nav") && rect.top >= 0) {
        offset = Math.max(offset, Math.ceil(rect.bottom) + 16);
      }
    });

    return offset;
  };

  root.querySelectorAll('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const href = link.getAttribute("href");
      if (!href || href === "#") return;

      const id = decodeURIComponent(href.slice(1));
      const target = document.getElementById(id);
      if (!target) return;

      event.preventDefault();
      const top = Math.max(
        0,
        window.scrollY + target.getBoundingClientRect().top - getOffset(),
      );
      window.scrollTo({
        top,
        behavior: reduceMotion ? "auto" : "smooth",
      });

      if (history.pushState) {
        history.pushState(null, "", href);
      } else {
        location.hash = href;
      }
    });
  });
}

// <details> の open 付け外しだけだと閉じる時に transition が効かずパッと閉じる。
// 高さアニメを JS で制御し、開閉とも常にふわっとさせる。
function initFaqAccordion(root) {
  const items = root.querySelectorAll(
    ".yr-lp__faq__item, .yr-lp__examples__item",
  );
  if (!items.length) return;

  const DURATION_MS = 350;

  items.forEach((item) => {
    const summary = item.querySelector(
      ":scope > .yr-lp__faq__question, :scope > .yr-lp__examples__summary",
    );
    const answer = item.querySelector(
      ":scope > .yr-lp__faq__answer, :scope > .yr-lp__examples__panel",
    );
    if (!summary || !answer) return;

    answer.style.overflow = "hidden";
    if (!item.open) {
      answer.style.height = "0px";
      item.classList.remove("is-expanded");
    } else {
      answer.style.height = "auto";
      item.classList.add("is-expanded");
    }

    summary.addEventListener("click", (event) => {
      event.preventDefault();
      if (item.dataset.animating === "1") return;

      if (item.open) {
        closeFaqItem(item, answer, DURATION_MS);
      } else {
        openFaqItem(item, answer, DURATION_MS);
      }
    });
  });
}

function openFaqItem(item, answer, durationMs) {
  item.dataset.animating = "1";
  item.open = true;
  item.classList.add("is-expanded");

  // slideToggle 相当: 展開スタイルで実高さを測ってから 0 → 実高さへ
  answer.style.transition = "none";
  answer.style.height = "auto";
  const target = answer.scrollHeight;
  answer.style.height = "0px";
  void answer.offsetHeight;

  answer.style.transition = `height ${durationMs}ms ease`;
  answer.style.height = `${target}px`;

  const finish = (event) => {
    if (event.propertyName && event.propertyName !== "height") return;
    answer.removeEventListener("transitionend", finish);
    window.clearTimeout(fallback);
    answer.style.height = "auto";
    answer.style.transition = "";
    item.dataset.animating = "0";
  };

  const fallback = window.setTimeout(() => finish({ propertyName: "height" }), durationMs + 80);
  answer.addEventListener("transitionend", finish);
}

function closeFaqItem(item, answer, durationMs) {
  item.dataset.animating = "1";

  answer.style.transition = "none";
  answer.style.height = `${answer.scrollHeight}px`;
  void answer.offsetHeight;

  item.classList.remove("is-expanded");
  answer.style.transition = `height ${durationMs}ms ease`;
  answer.style.height = "0px";

  const finish = (event) => {
    if (event.propertyName && event.propertyName !== "height") return;
    answer.removeEventListener("transitionend", finish);
    window.clearTimeout(fallback);
    item.open = false;
    answer.style.transition = "";
    item.dataset.animating = "0";
  };

  const fallback = window.setTimeout(() => finish({ propertyName: "height" }), durationMs + 80);
  answer.addEventListener("transitionend", finish);
}
